// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+5rV+","label-container":"styles_label-container__p3C6o","disabled-label":"styles_disabled-label__IN-JR","colored-label":"styles_colored-label__kW8vj"};